export default {
	data: null,
	error: null,
	status: '',
};
